import React, { FC, useEffect, useState, ComponentType } from 'react';
import AuthService from '@/services/AuthService';
import Loader from '@/pages/auth/components/Loader';

function AuthMiddleware<P extends object>(
  Wrapped: ComponentType<P>,
  requiredPermission?: string // 👈 optional permission key
): FC<P> {
  const ComponentWithAuth: FC<P> = (props: P) => {
    const [ready, setReady] = useState(false);
    const [ok, setOk] = useState(false);

    useEffect(() => {
      const validate = async () => {
        const authenticated = await AuthService.checkAuthAdmin();
        console.log('AuthMiddleware: authenticated =', authenticated);

        if (!authenticated) {
          await AuthService.logout();
          window.location.href = '/login';
          return;
        }

        // ✅ Now check permissions if required
        if (requiredPermission) {
          const roles = AuthService.getUserRoles();
          const isAdmin = roles.includes('admin');

          if (isAdmin || AuthService.hasPermission(requiredPermission)) {
            setOk(true);
          } else {
            setOk(false);
            window.location.href = '/403'; // Forbidden page
            return;
          }
        } else {
          // no specific permission required, just logged in
          setOk(true);
        }

        setReady(true);
      };

      validate();
    }, []);

    if (!ready) return <Loader />;
    return ok ? <Wrapped {...props} /> : null;
  };

  return ComponentWithAuth;
}

export default AuthMiddleware;
